module.exports = __webpack_public_path__ + "static/media/shape0.pngfeat0.e672a93c.png";